import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import { useEmbarqueDependencias } from "../../contexts/EmbarqueDependenciasContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController.js";
import TabelaRedux from "../../contexts/Tabela";
import SelectInputField from "../../core/data-entry/SelectInputField.tsx";
import { Veiculo } from "../../models/Veiculo.ts";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import ModalCadastro from "../ModalCadastro/ModalCadastro.tsx";
import "../ModalLancarVeiculo/ModalLancarVeiculo.css";
import NewIcon from "../NewIcon/NewIcon";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao: string;
	tituloConfirmar: string;
	texto: string;
	dataAlteracao: string;
	listaVeiculos?: any[];
	open: boolean;
	onClose: () => void;
	onClick: () => void;
	setVeiculo: (e) => void;
	setMotorista: (e) => void;
}

function ModalLancarVeiculo(props: SimpleDialogProps) {
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { veiculo } = useEmbarqueDependencias();

	const { tabelaRedux } = useContext(TabelaRedux);

	const placaSelecionadoChanged = useRef<string | null>(null);

	const { onClose, open, onClick } = props;


	const handleClose = () => {
		onClose();
		clearPlacaCavalo();
	};

	const handleClick = () => {
		onClick();
	};

	const defaultVeiculoOptions = useMemo(() => {
		return veiculo
			.filter((v) => v.caminhao || v.carreta || v.carreta2)
			.sort((a, b) => {
				const placaA =
					a.caminhao?.placa || "";
				const placaB =
					b.caminhao?.placa || "";
				return placaA.localeCompare(placaB);
			})
			.slice(0, 15)
			.map((data) => ({
				title: `${data.caminhao?.placa || ""} - ${data.proprietarioVeiculo?.nome ?? ""}`,
				obj: data,
			}));
	}, [veiculo]);

	const [values, setValues] = useState<any>([]);
	const [verificaMotorista2, setVerificaMorista2] = useState(true);
	const [listaMotoristas, setListaMotoristas] = useState<any>([]);
	const [listaMotoristas2, setListaMotoristas2] = useState<any>([]);
	const [valuesSelect, setValuesSelect] = useState<any>([]);
	const [idAtual, setIdAtual] = useState(0);
	const [disable, setDisable] = useState(false);
	const [openCadastroVeiculo, setOpenCadastroVeiculo] = useState(false);
	const [veiculoOptions, setVeiculoOptions] = useState(defaultVeiculoOptions);

	const handleCloseCadastroVeiculo = () => {
		if (idAtual) {
			setOpenCadastroVeiculo(false);
			setDadosRequestControllerRedux("Close Veiculo");
		} else {
			setDadosRequestControllerRedux("Close Veiculo");
		}
	};

	const clearPlacaCavalo = () => {
		setValues((current) => ({
			...current,
			veiculoId: null,
			placaCavalo: "",
			placaCarreta: "",
			placaCarreta2: "",
			proprietario: "",
			motorista: "",
		}));
		setValuesSelect((current) => ({ ...current, placaCavalo: "" }));
	};

	const handleVeiculoInputChange = useCallback(
		(inputValue: React.ChangeEvent<HTMLInputElement>) => {
			const normalizedInput = inputValue.target.value.trim().toLowerCase();

			if (normalizedInput === "") {
				setVeiculoOptions([]);
				return;
			}

			const filteredOptions = veiculo
				.filter((veiculo) => {
					const placa =
						veiculo.caminhao?.placa?.toLowerCase() ||
						"";
					const proprietario =
						veiculo.proprietarioVeiculo?.nome?.toLowerCase() || "";

					return (
						placa.includes(normalizedInput) ||
						proprietario.includes(normalizedInput)
					);
				})
				.map((data) => ({
					title: `${data.caminhao?.placa} - ${data.proprietarioVeiculo?.nome ?? ""}`,
					obj: data,
				}))
				.sort((a, b) => a.title.localeCompare(b.title));

			setVeiculoOptions(filteredOptions);
		},
		[veiculo, setVeiculoOptions]
	);

	const handlePlacaCavaloChange = useCallback(
		(selectedOption: { obj: Veiculo, title: string }) => {
			const selectedOptionData = selectedOption.obj;
			if (selectedOptionData) {
				if (
					!!selectedOptionData.motorista2Id
				) {
					setVerificaMorista2(false);
					setListaMotoristas2(selectedOptionData.veiculoMotorista2);
				} else {
					setVerificaMorista2(true);
					props.setMotorista(selectedOptionData.veiculoMotorista?.nome);
				}
				setListaMotoristas(selectedOptionData.veiculoMotorista?.nome);
				props.setVeiculo(selectedOptionData.idVeiculo);
				setValues((current) => ({
					...current,
					veiculoId: selectedOptionData.idVeiculo,
					placaCavalo: selectedOptionData.caminhao?.placa,
					placaCarreta: selectedOptionData.carreta?.placa,
					placaCarreta2: selectedOptionData.carreta2?.placa,
					proprietario: selectedOptionData.proprietarioVeiculo?.nome,
					motorista: selectedOptionData.veiculoMotorista?.nome,
				}));
				setValuesSelect((current) => ({
					...current,
					placaCavalo: {
						obj: selectedOptionData,
						title: selectedOption.title,
					},
				}));
			}
		},
		[props]
	);

	const opcoesCavalo = useMemo(() => {
		return veiculo?.map((data) => ({
			obj: data.caminhao?.placa || "",
			title: data.caminhao?.placa || "",
			...data
		}));
	}, [veiculo]);

	const estiloFrota = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const placaSelecionado = useMemo(() => {
		return opcoesCavalo?.find(
			(option) => option.title === tabelaRedux?.row?.placaCavalo
		);
	}, [tabelaRedux?.row?.placaCavalo, opcoesCavalo]);

	useEffect(() => {
		if (!!placaSelecionado && placaSelecionado?.title !== placaSelecionadoChanged.current) {

			const updatedValues = {
				veiculoId: placaSelecionado.idVeiculo,
				placaCavalo: placaSelecionado.caminhao?.placa,
				placaCarreta: placaSelecionado.carreta?.placa,
				placaCarreta2: placaSelecionado.carreta2?.placa,
				proprietario: placaSelecionado.proprietarioVeiculo?.nome,
				motorista: placaSelecionado.veiculoMotorista?.nome,
			};

			setValuesSelect((current) => ({
				...current,
				placaCavalo: placaSelecionado,
			}));

			setValues((current) => ({
				...current,
				...updatedValues,
			}));

			props.setVeiculo(placaSelecionado.idVeiculo);
			props.setMotorista(updatedValues.motorista);
			placaSelecionadoChanged.current = placaSelecionado?.title || null;
		}
	}, [tabelaRedux, opcoesCavalo, props, placaSelecionado, props.setVeiculo, props.setMotorista]);

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent className="content-veiculo">
						<div>
							<div className="coluna-lancar-veiculo">
								<div className="coluna-emb">
									<SelectInputField
										label="Placa do Cavalo:"
										placeholder="Digite para buscar."
										disabled={false}
										options={veiculoOptions}
										value={valuesSelect.placaCavalo?.title || ""}
										onChange={handlePlacaCavaloChange}
										onInputChange={handleVeiculoInputChange}
										onClear={clearPlacaCavalo}
									/>
									<NewIcon
										onClick={(e) => {
											setOpenCadastroVeiculo(true);
											setIdAtual(0);
											setDisable(false);
										}}
									/>
								</div>
								<div className="coluna-emb">
									<div>
										<p className="input-label-emb">Proprietário:</p>
										<input
											type="text"
											className="input-emb"
											style={{ width: "290px" }}
											onChange={(e) => {
												setValues((current) => ({
													...current,
													proprietario: e.target.value,
												}));
											}}
											value={values.proprietario}
											disabled={true}
										/>
									</div>
								</div>
								<div className="coluna-emb">
									<div>
										<p className="input-label-emb">Placa da Carreta:</p>
										<input
											type="text"
											className="input-emb"
											style={{ width: "290px" }}
											onChange={(e) => {
												setValues((current) => ({
													...current,
													placaCarreta: e.target.value,
												}));
											}}
											value={values.placaCarreta}
											disabled={true}
										/>
									</div>
								</div>
								<div className="coluna-emb">
									<div>
										<p className="input-label-emb">Motorista:</p>
										{verificaMotorista2 ? (
											<input
												type="text"
												className="input-emb"
												style={{ width: "290px" }}
												onChange={(e) => {
													setValues((current) => ({
														...current,
														motorista: e.target.value,
													}));
													props.setMotorista(e.target.value);
												}}
												value={values.motorista}
												disabled={verificaMotorista2}
											/>
										) : (
											<Select
												options={[
													{ value: listaMotoristas, label: listaMotoristas },
													{
														value: listaMotoristas2,
														label: listaMotoristas2,
													},
												]}
												styles={estiloFrota}
												value={{
													value: values.motorista,
													label: values.motorista,
												}}
												isDisabled={verificaMotorista2}
												onChange={(selectedOption) => {
													setValues((current) => ({
														...current,
														motorista: selectedOption?.value,
													}));
													props.setMotorista(selectedOption?.value);
												}}
											/>
										)}
									</div>
								</div>
								<div className="coluna-emb">
									<div>
										<p className="input-label-emb">Placa Segunda Carreta:</p>
										<input
											type="text"
											className="input-emb"
											style={{ width: "290px" }}
											onChange={(e) => {
												setValues((current) => ({
													...current,
													placaCarreta2: e.target.value,
												}));
											}}
											value={values.placaCarreta2}
											disabled={true}
										/>
									</div>
								</div>
							</div>
						</div>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="OK"
							cor="#0946B8"
							onClick={handleClick}
						/>
						<CustomButtonV2
							classCss="custom-button-cancelar"
							classText="button-texto-cancelar"
							titulo="Cancelar"
							cor="#0946B8"
							onClick={handleClose}
						/>
					</DialogActions>
				</div>
			</Dialog>
			<div>
				<ModalCadastro
					titulo="Cadastro"
					tituloConfirmar="OK"
					cadastroVeiculo="sim"
					open={openCadastroVeiculo}
					idAtual={idAtual}
					desabilitar={disable}
					onClose={handleCloseCadastroVeiculo}
				/>
			</div>
		</div>
	);
}

export default ModalLancarVeiculo;
